import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Header from "../../shef_dashboard/components/Header";
import BeforeFooter from "../../frontend/components/homeWidget/BeforeFooter";
import { useSelector } from "react-redux";
import { handleGetAllDishes, handleGetTransaction, handlePostTransaction } from "../../services/shef";
import isValidURL from "../../ValidateUrl";
import moment from "moment";
import {
  handleGetOrders,
  handleGetPendingOrdersForChef,
} from "../../services/order";
import Footer from "../../frontend/components/Footer";

export const Dashboard = () => {
  const navigate = useNavigate();

  const [dishes, setDishes] = useState([]);
  const [isLoadingDishes, setIsLoadingDishes] = useState(true);
  const [isLoadingSales, setIsLoadingSales] = useState(true);
  const [sales, setSales] = useState({});
  

  const [dateRange, setdateRange] = useState({
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });
  const [pendingOrderCount, setPendingOrderCount] = useState(null);
  const [upcomingOrdersCount, setUpcomingOrdersCount] = useState({
    accepted: null,
    preparing: null,
    delivering: null,
    canceled: null,
    delivered: null,
  });
  const { authToken, userInfo } = useSelector((state) => state.user);

  useEffect(() => {
    // Fetch dishes
    (async () => {
      try {
        setIsLoadingDishes(true);
        const res = await handleGetAllDishes(authToken);
        setDishes(res);
      } catch (error) {
        console.error("Error while fetching dishes \n", error);
      } finally {
        setIsLoadingDishes(false);
      }
    })();
    
    // Fetch sales data
    (async () => {
      try {
        setIsLoadingSales(true);
        const res = await handlePostTransaction(
          authToken,
          userInfo?.id
        );

        let data = res.reports.original.reports
        ? res.reports.original.reports
        : res.reports.original.data;
      var transformedOrders = data.flatMap((order) =>
        order.reports.map((report) => ({
          ...order,
          ...report,
          reports: undefined,
        }))
      );

        const calculatedSales = transformedOrders.reduce(
          (acc, item) => {
            acc.total_amount += item.total_amount;
            acc.service_charges += item.service_charges;
            acc.commission_received += item.commission_received;
            acc.net_delivery_charges += item.net_delivery_charges;
            acc.sale_amount += item.sale_amount;
            return acc;
          },
          {
            total_amount: 0,
            service_charges: 0,
            commission_received: 0,
            net_delivery_charges: 0,
            sale_amount: 0,
          }
        );
        setSales(calculatedSales);
      } catch (error) {
        console.error("Error while fetching sales data \n", error);
      } finally {
        setIsLoadingSales(false);
      }
    })();

    // Fetch orders
    const fetchOrders = async () => {
      try {
        const ordersRetrieved = await handleGetOrders(authToken, {
          chef_id: userInfo.id,
        });

        const updatedOrdersCount = { ...upcomingOrdersCount };

        Object.keys(updatedOrdersCount).forEach((key) => {
          if (updatedOrdersCount[key] === null) {
            updatedOrdersCount[key] = 0;
          }
        });

        ordersRetrieved.forEach((order) => {
          if (updatedOrdersCount.hasOwnProperty(order.status)) {
            updatedOrdersCount[order.status]++;
          }
        });

        Object.keys(updatedOrdersCount).forEach((key) => {
          if (updatedOrdersCount[key] === 0) {
            updatedOrdersCount[key] = 0;
          }
        });

        setUpcomingOrdersCount(updatedOrdersCount);
      } catch (error) {
        console.log("Error While Fetching Orders \n", error);
      }
    };
    fetchOrders();

    let intervalId;

    const fetchPendingOrderCount = async () => {
      try {
        const pendingOrderResponse = await handleGetPendingOrdersForChef(
          userInfo.id,
          authToken
        );
        setPendingOrderCount(pendingOrderResponse);
      } catch (error) {
        console.error("Error while fetching Pending orders \n", error);
      }
    };
    if (userInfo.is_chef === 1 || userInfo.is_admin === 1) {
      fetchPendingOrderCount();

      intervalId = setInterval(() => {
        fetchPendingOrderCount();
      }, 300000);
    }
  }, [authToken]);

  const handleImageClick = (dish) => {
      navigate("/shef/my-menu", { state: dish });
  };

  return (
    <div className="bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen">
      <Header />
      <div className="container mx-auto px-4 py-8 max-w-7xl">
        {/* Dashboard Header */}
        <div className="mb-12">
          <h1 className="text-4xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-gray-900 to-gray-700 mb-2">
            Welcome Back, {userInfo?.name || 'Shef'}!
          </h1>
          <p className="text-gray-600 text-lg">
            Here's what's happening with your kitchen today
          </p>
        </div>

        {/* Orders Overview */}
        <div className="bg-white rounded-2xl p-8 mb-8 shadow-xl border border-gray-100">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-12 h-12 bg-gradient-to-br from-red-600 to-red-500 rounded-xl flex items-center justify-center text-white text-xl">
              📋
            </div>
            <h2 className="text-2xl font-bold text-gray-900">Your Orders Overview</h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
            {upcomingOrdersCount?.accepted === null
              ? Array(5)
                  .fill(null)
                  .map((_, index) => (
                    <div
                      key={index}
                      className="bg-gradient-to-br from-white to-gray-50 p-6 rounded-xl border-2 border-transparent hover:border-red-600 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
                    >
                      <div className="h-6 bg-gray-200 rounded-md mb-4 w-3/4 mx-auto"></div>
                      <div className="h-8 bg-gray-200 rounded-md w-1/2 mx-auto"></div>
                    </div>
                  ))
              : [
                  { label: "Accepted Orders", count: upcomingOrdersCount?.accepted },
                  { label: "Cancelled Orders", count: upcomingOrdersCount?.canceled },
                  { label: "Preparing Orders", count: upcomingOrdersCount?.preparing },
                  { label: "Delivering Orders", count: upcomingOrdersCount?.delivering },
                  { label: "Delivered Orders", count: upcomingOrdersCount?.delivered },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="bg-gradient-to-br from-white to-gray-50 p-6 rounded-xl border-2 border-transparent hover:border-red-600 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 relative overflow-hidden"
                  >
                    <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-red-600 via-red-500 to-orange-500 opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
                    <h6 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-1">
                      {item.label}
                    </h6>
                    <span className="text-3xl font-extrabold text-gray-900">
                      {item.count || 0}
                    </span>
                  </div>
                ))}
          </div>
        </div>

        {/* Pending Orders - UPDATED TO NAVIGATE */}
        <div className="bg-white rounded-2xl p-8 mb-8 shadow-xl border border-gray-100">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-12 h-12 bg-gradient-to-br from-red-600 to-red-500 rounded-xl flex items-center justify-center text-white text-xl">
              ⏳
            </div>
            <h2 className="text-2xl font-bold text-gray-900">Pending Orders</h2>
          </div>
          
          <div 
            onClick={() => navigate("/shef/order", { state: { activeTab: "pending" } })}
            className="bg-gradient-to-br from-amber-100 to-amber-50 rounded-xl p-8 text-center border-2 border-amber-300 relative overflow-hidden cursor-pointer hover:shadow-lg hover:scale-[1.01] transition-all duration-300"
          >
            <div className="absolute -top-1/2 -right-1/2 w-full h-full bg-radial-gradient(circle, rgba(245,158,11,0.1), transparent) animate-pulse opacity-30"></div>
            <h6 className="text-sm font-semibold text-amber-800 uppercase tracking-wider mb-2">
              Orders Awaiting Action
            </h6>
            <div className="text-5xl font-extrabold text-amber-900 mb-2">
              {pendingOrderCount || 0}
            </div>
            <p className="text-amber-800 font-medium">
              {pendingOrderCount === 0 ? "All caught up! No pending orders at the moment." : "You have orders to review! Click to view."}
            </p>
          </div>
        </div>

        {/* Sales Overview */}
        <div className="bg-white rounded-2xl p-8 mb-8 shadow-xl border border-gray-100">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-12 h-12 bg-gradient-to-br from-red-600 to-red-500 rounded-xl flex items-center justify-center text-white text-xl">
              💰
            </div>
            <h2 className="text-2xl font-bold text-gray-900">Your Sales Performance</h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
            {isLoadingSales
              ? [1, 2, 3, 4, 5].map((_, index) => (
                  <div
                    key={index}
                    className="bg-gradient-to-br from-white to-gray-50 p-6 rounded-xl border-2 border-transparent hover:border-red-600 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
                  >
                    <div className="h-6 bg-gray-200 rounded-md mb-4 w-3/4 mx-auto"></div>
                    <div className="h-8 bg-gray-200 rounded-md w-1/2 mx-auto"></div>
                  </div>
                ))
              : [
                  { label: "Total Sales", value: sales?.sale_amount },
                  { label: "Total Amount", value: sales?.total_amount },
                  { label: "Delivery Charges", value: sales?.net_delivery_charges },
                  { label: "Commission", value: sales?.commission_received },
                  { label: "Service Charges", value: sales?.service_charges },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="bg-gradient-to-br from-white to-gray-50 p-6 rounded-xl border-2 border-transparent hover:border-red-600 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 relative overflow-hidden"
                  >
                    <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-red-600 via-red-500 to-orange-500 opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
                    <h6 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-1">
                      {item.label}
                    </h6>
                    <span className="text-2xl font-extrabold text-gray-900">
                      {item.label.includes('Total Sales') ? item.value || 0 : `₨${item.value || 0}`}
                    </span>
                  </div>
                ))}
          </div>
        </div>

        {/* Menu Section */}
        <div className="bg-white rounded-2xl p-8 mb-8 shadow-xl border border-gray-100">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-12 h-12 bg-gradient-to-br from-red-600 to-red-500 rounded-xl flex items-center justify-center text-white text-xl">
              🍽️
            </div>
            <h2 className="text-2xl font-bold text-gray-900">Your Menu</h2>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 mb-8">
            {isLoadingDishes ? (
              // Show skeleton while loading
              Array(4)
                .fill(0)
                .map((_, index) => (
                  <div key={index} className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-4 border-2 border-gray-200 hover:border-red-600 transition-all duration-300 hover:shadow-md hover:-translate-y-1">
                    <div className="h-32 bg-gray-200 rounded-lg mb-3 animate-pulse"></div>
                    <div className="h-5 bg-gray-200 rounded-md w-3/4 mx-auto"></div>
                  </div>
                ))
            ) : dishes.length > 0 ? (
              // Show dishes if available
              dishes.map((dish, index) => (
                <div 
                  key={index} 
                  className="text-center cursor-pointer group"
                  onClick={() => handleImageClick(dish)}
                >
                  <div className="relative overflow-hidden rounded-xl mb-3 group-hover:shadow-md transition-all duration-300">
                    <img
                      src={
                        dish.logo && isValidURL(dish.logo)
                          ? dish.logo
                          : "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/330px-No-Image-Placeholder.svg.png?20200912122019"
                      }
                      alt="Dish"
                      className="w-full h-32 object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 truncate max-w-[200px]" title={dish.name}>
                  {dish.name}
                    </h3>

                </div>
              ))
            ) : (
              // Show message if no dishes found
              <div className="col-span-full text-center py-8">
                <div className="bg-gray-50 rounded-xl p-8 max-w-md mx-auto border-2 border-dashed border-gray-300">
                  <div className="text-5xl text-gray-300 mb-4">🍽️</div>
                  <h3 className="text-xl font-semibold text-gray-700 mb-2">Your menu is empty</h3>
                  <p className="text-gray-500 mb-6">
                    No dishes found in your menu. Add your delicious creations to start receiving orders!
                  </p>
                </div>
              </div>
            )}
          </div>
          
          <div className="flex justify-center gap-4">
            <NavLink 
              to="/shef/my-menu" 
              className="bg-gradient-to-br from-red-600 to-red-500 !text-white px-6 py-3 rounded-xl font-semibold hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
            >
              + Add New Dish
            </NavLink>
            <NavLink 
              to="/shef/my-menu" 
              className="bg-white text-red-700 px-6 py-3 rounded-xl font-semibold border border-red-600 hover:bg-red-50 hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
            >
              Manage Menu
            </NavLink>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          {/* Profile Card */}
          <NavLink to="/shef/profile" className="block">
            <div className="bg-white rounded-2xl p-8 shadow-xl border border-gray-100 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 h-full relative overflow-hidden">
              <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-red-600 to-red-500 opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
              <div className="w-16 h-16 bg-gradient-to-br from-red-600 to-red-500 rounded-2xl flex items-center justify-center text-white text-2xl mx-auto mb-4">
                👤
              </div>
              <h3 className="text-xl font-bold text-center text-gray-900 mb-1">Your Profile</h3>
              <p className="text-red-600 text-center font-medium mb-6">Update your Profile!</p>
              <div className="text-center">
                <button className="bg-gradient-to-br from-red-600 to-red-500 text-white px-6 py-2 rounded-lg font-semibold hover:shadow-md transition-all duration-300">
                  Edit Profile
                </button>
              </div>
            </div>
          </NavLink>

          {/* Order Review Card */}
          <NavLink to="/shef/order-review" className="block">
            <div className="bg-white rounded-2xl p-8 shadow-xl border border-gray-100 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 h-full relative overflow-hidden">
              <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-red-600 to-red-500 opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
              <div className="w-16 h-16 bg-gradient-to-br from-red-600 to-red-500 rounded-2xl flex items-center justify-center text-white text-2xl mx-auto mb-4">
                📝
              </div>
              <h3 className="text-xl font-bold text-center text-gray-900 mb-1">Order Reviews</h3>
              <p className="text-red-600 text-center font-medium mb-6">See your Order Review!</p>
              <div className="text-center">
                <button className="bg-gradient-to-br from-red-600 to-red-500 text-white px-6 py-2 rounded-lg font-semibold hover:shadow-md transition-all duration-300">
                  View Reviews
                </button>
              </div>
            </div>
          </NavLink>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default Dashboard;